import { inject, Injectable, signal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { MatBottomSheetService, RestService } from 'src/app/services';
import { PayloadSendModularSurvey, StructureField } from '../interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModularSurveyForm {
  // Service injections
  private _restService = inject(RestService); // TODO: ESTO CAMBIARA EN SSR
  private _matBottomSheetService = inject(MatBottomSheetService);

  // State signals
  private _markAllFormFieldsAsTouched = signal<boolean>(false);

  // Getters
  public markAllFormFieldsAsTouched = this._markAllFormFieldsAsTouched.asReadonly();

  // Setters
  public setMarkAllFormFieldsAsTouched(markAsTouched: boolean): void {
    this._markAllFormFieldsAsTouched.set(markAsTouched);
  }

  // Methods
  public submitForm(formGroup: FormGroup, surveyId: number, fieldList: StructureField[]): Observable<unknown> {
    const payload = this.buildPayload(formGroup, surveyId, fieldList);
    return this._restService.saveSurvey(payload);
  }

  buildPayload(formGroup: FormGroup,
               surveyId: number,
               fieldList: StructureField[]
              ): PayloadSendModularSurvey | undefined
  {
    if (!formGroup) return;

    const data = fieldList.map((field, index) => {
      const formControlName = `${field.type}_${index}`;
      return {
        question: field.title ?? '',
        type: field.type,
        answer: formGroup.get(formControlName)?.value
      };
    });

    return {
      survey_id: surveyId.toString(),
      data: data
    }
  }

  public markFieldAsTouched(control: AbstractControl | null): void {
    control?.markAsTouched();
    control?.markAsDirty();
  }

  public isInvalidField(control: AbstractControl | null): boolean {
    return !!control && control.invalid && (control.touched || control.dirty);
  }

  toggleBottomSheet() {
    this._matBottomSheetService.closeAllMatBottomSheets();
  }
}
